import {customElement, bindable} from 'aurelia-framework';
import * as _ from 'lodash';
import "./log.less";

@customElement('sio-log-automatically-stamped')
export class LogAutomaticallyStamped
{
    @bindable log;
}
